// Constants
import {
    ELEMENT_RESIZING_ALLOW_ANY_ASPECT_RATIO,
    ELEMENT_RESIZING_END,
    ELEMENT_RESIZING_START,
    ELEMENT_RESIZING_UPDATE_ELEMENT_VALUES,
    ELEMENT_RESIZING_UPDATE_SCALE,
} from './resizingConstants';

export const startElementResizing = (elementIds, origin) => ({
    type: ELEMENT_RESIZING_START,
    elementIds,
    origin,
});

export const endElementResizing = () => ({
    type: ELEMENT_RESIZING_END,
});

export const updateResizeScale = (scale) => ({
    type: ELEMENT_RESIZING_UPDATE_SCALE,
    scale,
});

export const updateAllowChangingAspectRatio = (allowChangingAspectRatio) => ({
    type: ELEMENT_RESIZING_ALLOW_ANY_ASPECT_RATIO,
    allowChangingAspectRatio,
});

export const updateElementResizingValues = (elementId, resizingValues) => ({
    type: ELEMENT_RESIZING_UPDATE_ELEMENT_VALUES,
    elementId,
    resizingValues,
});
